var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBillingDoneTagIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 5.34375L11.5 1.21875C11.2188 0.9375 10.75 0.9375 10.4375 1.25C10.1562 1.53125 10.1562 2 10.4688 2.3125L14.6875 6.40625C15.2188 6.9375 15.5 7.59375 15.5 8.3125C15.5 9.03125 15.2188 9.71875 14.6875 10.2188L11.2188 13.75C10.9062 14.0312 10.9062 14.5 11.2188 14.8125C11.3438 14.9375 11.5312 15 11.75 15C11.9375 15 12.125 14.9375 12.2812 14.7812L15.75 11.2812C16.5625 10.5 17 9.4375 17 8.3125C17 7.1875 16.5625 6.15625 15.75 5.34375ZM13.4688 7.0625L7.9375 1.53125C7.65625 1.25 7.09375 1 6.6875 1H0.875C0.375 1 0 1.40625 0 1.875V7.71875C0 8.125 0.21875 8.6875 0.5 8.96875L6.03125 14.5C6.71875 15.1875 7.8125 15.1875 8.5 14.5L13.4688 9.53125C14.1562 8.84375 14.1562 7.75 13.4688 7.0625ZM3.5 5.5C2.9375 5.5 2.5 5.0625 2.5 4.5C2.5 3.96875 2.9375 3.5 3.5 3.5C4.03125 3.5 4.5 3.96875 4.5 4.5C4.5 5.0625 4.03125 5.5 3.5 5.5Z",
    fill: "#9AAAC7"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBillingDoneTagIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/billing-done-tag-icon.ea9488b2bdf8e92f35055638f6eb043a.svg";